module.exports = __webpack_public_path__ + "static/media/cy.ce826661.svg";